import { render } from "./ImportList.vue?vue&type=template&id=6a71dffc"
import script from "./ImportList.vue?vue&type=script&lang=js"
export * from "./ImportList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__